import * as action from './actions';

import * as actionTypes from './actionTypes';

import { ModalName } from 'types/modals';
import { InferValueTypes } from 'types/commonTypes';

type ActionType = ReturnType<InferValueTypes<typeof action>>;

export type ModalState = { modalId?: ModalName; modalProps?: any };

const initialState: ModalState = {};

const modalsReducer = (state = initialState, action: ActionType): ModalState => {
  switch (action.type) {
    case actionTypes.OPEN_MODAL:
      return { ...state, ...action.payload };

    case actionTypes.CLOSE_MODAL:
      return { ...initialState };

    default:
      return state;
  }
};

export default modalsReducer;
